import apiUrl from '../baseUrls/functions';
import AxiosService from '../axiosConfig/AxiosService';

export default new class PlaqueService {
    
    get = (callback, queryParams) => AxiosService.get(apiUrl('/api/crud/plaque/get'), callback, queryParams);
    getById = (id, callback) => AxiosService.get(apiUrl(`/api/crud/plaque/get/${id}`), callback);
    add = (data, callback) => AxiosService.post(apiUrl('/api/crud/plaque/add'), data, callback);
    update = (data, callback) => AxiosService.put(apiUrl('/api/crud/plaque/update'), data, callback);
    delete = (id, callback) => AxiosService.delete(apiUrl(`/api/crud/plaque/delete/${id}`), callback);
    
}